var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { initProcessService } from "../../apis";
export const processPorts = {
    getProcessDefinitionList(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield initProcessService().getProcessDefinitionList({
                body: Object.assign({}, query),
            });
            return res;
        });
    },
    getProcessDefinition(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield initProcessService().getProcessDefinition({
                body: Object.assign({}, query),
            });
            return res;
        });
    },
    getProcessInstanceList(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield initProcessService().getProcessInstanceList({
                body: Object.assign({}, query),
            });
            return res;
        });
    },
    getProcessInstance(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield initProcessService().getProcessInstance({
                body: Object.assign({}, query),
            });
            return res;
        });
    },
    getTaskDefinitionList(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield initProcessService().getTaskDefinitionList({
                body: Object.assign({}, query),
            });
            return res;
        });
    },
    getTaskDefinition(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield initProcessService().getTaskDefinition({
                body: Object.assign({}, query),
            });
            return res;
        });
    },
    getTaskInstanceList(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield initProcessService().getTaskInstanceList({
                body: Object.assign({}, query),
            });
            return res;
        });
    },
    getTaskInstanceListV2(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield initProcessService().getTaskInstanceListV2({
                body: Object.assign({}, query),
            });
            return res;
        });
    },
    getTaskInstance(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield initProcessService().getTaskInstance({
                body: Object.assign({}, query),
            });
            return res;
        });
    },
    getTaskInstanceV2(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield initProcessService().getTaskInstanceV2({
                body: Object.assign({}, query),
            });
            return res;
        });
    },
    claimTaskInstance(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield initProcessService().claimTaskInstance({
                body: Object.assign({}, query),
            });
            return res;
        });
    },
    unclaimTaskInstance(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield initProcessService().unclaimTaskInstance({
                body: Object.assign({}, query),
            });
            return res;
        });
    },
    getTaskDestinationUrl(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield initProcessService().getTaskDestinationUrl({
                body: Object.assign({}, query),
            });
            return res;
        });
    },
    transferTaskInstance(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield initProcessService().transferTaskInstance({
                body: Object.assign({}, query),
            });
            return res;
        });
    },
    withdrawProcessInstance(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield initProcessService().withdrawProcessInstance({
                body: Object.assign({}, query),
            });
            return res;
        });
    },
    endProcessInstance(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield initProcessService().endProcessInstance({
                body: Object.assign({}, query),
            });
            return res;
        });
    },
    getRejectableTaskDefinitionList(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield initProcessService().getRejectableTaskDefinitionList({
                body: Object.assign({}, query),
            });
            return res;
        });
    },
    setProcessDefinitionState(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield initProcessService().setProcessDefinitionState({
                body: Object.assign({}, query),
            });
            return res;
        });
    },
    updateTaskDefinitionStrategy(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield initProcessService().updateTaskDefinitionStrategy({
                body: Object.assign({}, query),
            });
            return res;
        });
    },
};
